<template>
  <div>
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="400px"
      transition="dialog-transition"
    >
      <div class="bg-white p-10">
        <div class="text-xl font-bold border-b border-gray-400 mb-2 pb-2">Your appointment request has been received.</div>
        <div>
          This will now undergo assessment. Once submitted, you may see the
          status of your request on your Dashboard.
        </div>

        <div class="md:flex justify-center pt-4">
          <v-btn class="md:mr-2" color="black" dark @click="end('Home Dashboard')">
            Home Page
          </v-btn>
          <v-btn color="black" dark @click="end('Customer Dashboard')">
            Dashboard
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["showDialog"],
  methods: {
    end(e) {
      this.$emit("endButton", e);
    },
  },
};
</script>